const PERMISSION_KEY= "core:file_manager";
const PAGE_URL = {
    FILE_MANAGER_PAGE: "/admin/core/file-manager"
}

export {PERMISSION_KEY, PAGE_URL}

